var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18031 4.83904C0.715459 4.32382 0.661391 3.61499 1.05678 3.2196L3.14801 1.12838C3.54339 0.732989 4.25222 0.787058 4.76744 1.25191L10.476 6.40236C11.0399 6.91108 11.1508 7.70767 10.7181 8.14037L8.06878 10.7897C7.63607 11.2224 6.83948 11.1115 6.33076 10.5476L1.18031 4.83904Z",
    fill: "#8FBCF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64024 5.52941C4.64476 5.04498 5.03636 4.65338 5.52079 4.64886L12.1812 4.58666C12.977 4.57923 13.3808 5.54124 12.818 6.10405L6.09543 12.8266C5.53262 13.3894 4.57061 12.9857 4.57804 12.1898L4.64024 5.52941Z",
    fill: "#8FBCF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28793 9.0565L9.17355 7.17088L15.0527 13.9907C15.2817 14.2564 15.267 14.6538 15.019 14.9019C14.7709 15.15 14.3734 15.1647 14.1077 14.9356L7.28793 9.0565Z",
    fill: "#8FBCF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFill);
export default __webpack_public_path__ + "static/media/pinFill.29fc0a0f31ae13f0907375d5ee1a2de5.svg";
export { ForwardRef as ReactComponent };